import {StockService} from '../../home/services/stocks.service';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Input, Output, EventEmitter, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



@Component({
  selector: 'app-product-view-modal',
  templateUrl: './product-view-modal.component.html',
  styleUrls: ['./product-view-modal.component.scss']
})
export class ProductViewModalComponent implements OnInit {
  public productData: any;
  public filter: any;
  public selectedIndex: any = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By Name';
  public productObj: any;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  page = 1;
  // tslint:disable-next-line:max-line-length
  constructor(public dialogRef: MatDialogRef<ProductViewModalComponent>, public masterservice: MasterService, public stockService: StockService) { }

  ngOnInit() {
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getProduct();
  }

  getProduct() {
    this.masterservice.getIndex('/products/index', this.filter).subscribe(res => {
      // @ts-ignore
      this.productData = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.current_page = res.data.current_page;
      // @ts-ignore
      this.per_page = res.data.per_page;
    });
  }

  close() {
    this.dialogRef.close();
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  sendSelected(i) {
    this.productObj = this.productData[i];
    if (this.productObj) {
      this.dialogRef.close({ data: this.productObj });
    }
  }

  getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By Name';
          break;
        case '1':
          this.placeHolder = 'Search By Code';
          break;
        default: this.placeHolder = 'Search By Name';
      }
    }
  }

  doSearch() {

  if (this.searchBy != null) {
      if (this.searchBy === 0) {
        Object.assign(this.filter, {search: { type: 'str', field: 'products.name', text: this.searchTxt}});
      } else {
        Object.assign(this.filter, {search: { type: 'str', field: 'products.code', text: this.searchTxt}});
      }
    }
  this.getProduct();
  }

  doRefresh() {
    this.searchTxt = null;
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getProduct();
  }

  doPaginate(e) {
    Object.assign(this.filter, {page: e});
    this.getProduct();
  }
}

